import useSWR from 'swr';
import grispiApiBasic from '../apis/grispiApiBasic';
import { customSWRResponse } from '../model/types';

export default function useApiVersion(): customSWRResponse<any> {
    return useSWR('/version', grispiApiBasic, {
        revalidateOnFocus: false,
        revalidateIfStale: false,
        revalidateOnReconnect: false
    });
}
